import { useEffect } from 'react';
import { useOperatorStore } from '../features/operator/store/operator-store';

/**
 * Updates the document title based on the active operator
 *
 * Default: "Monta - Maps"
 * With operator: "{Operator Name} - Maps" (e.g., "Norlys - Maps")
 */
export function useDocumentTitle() {
  const operator = useOperatorStore((s) => s.operator);
  const isOperatorInitialized = useOperatorStore((s) => s.isInitialized);

  useEffect(() => {
    // Wait for operator store to initialize
    if (!isOperatorInitialized) return;

    // Set title based on operator
    if (operator && operator.identifier !== 'monta') {
      // Use operator name from the store
      document.title = `${operator.name} - Maps`;
    } else {
      // Default Monta title
      document.title = 'Monta - Maps';
    }
  }, [operator, isOperatorInitialized]);
}
